import { Typography } from '@arionbanki/arionui';
import { FLOW_TYPE } from 'consts/flows';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';

export function RiskqTextBottom() {
	const { flowType, t } = useContext(AppContext);

	if (FLOW_TYPE.RR_SU === flowType) {
		return (
			<Typography className="mt-5 mb-4" TagName="p">
				{t('rr-su_riskq_text_bottom', 'riskq')}
			</Typography>
		);
	}

	return null;
}
